// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfMonth/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfMonth = convertToFP(fn, 1);
export default endOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfMonth/index.js
// module id = 864
// module chunks = 0